/**
 * Per-unlock_key speech line for emote bubbles (Profile + BattleUI).
 * Keys must match unlock_catalog.unlock_key for unlock_type = 'emote'.
 */

export const EMOTE_SPEECH_LINES_EN = {
  // Base catalog rows (create_emotes_catalog.sql / add_more_emotes_example.sql) — speech_bubble text
  emote_good_game: 'Good game!',
  emote_greet: 'Hello!',
  emote_laugh: 'Haha!',
  emote_oops: 'Oops!',
  emote_taunt: "You're no match for me!",
  emote_thanks: 'Thanks!',
  emote_wake_up: 'Wake up!',
  emote_well_played: 'Well played!',
  emote_wish_luck: 'Good luck!',
  emote_greet_stars_align: 'May the stars align for you',
  emote_greet_signal_locked: "Signal locked. Let's roll",
  emote_greet_salutations: 'Salutations',
  emote_greet_commander_deck: 'Commander on deck!',
  emote_greet_victory_awaits: 'Victory awaits',
  emote_greet_for_earth: 'For Earth!',
  emote_greet_lets_get_on: "Let's get on with it",
  emote_greet_beep_bopp: 'Beep. Bopp!',
  emote_greet_prepare_bad_time: 'Prepare for a bad time',
  emote_greet_meet_end_dignity: 'Meet your end with dignity',
  emote_greet_hello_friend: 'Hello, friend',
  emote_greet_we_finally_meet: 'We finally meet!',
  emote_greet_those_who_die: 'Those who are about to die salute you',
  emote_greet_all_systems_go: 'All systems are a go!',
  emote_greet_ready_fate: 'Ready to meet my fate',
  emote_greet_here_we_go: 'Here we go!',
  emote_greet_atoms_oscillate: 'May your atoms oscillate in harmony',
  emote_greet_resistance_appreciated: 'Resistance is appreciated',
  emote_greet_small_challenge: 'Try to be at least a small challenge',
  emote_greet_systems_calibrated: 'Systems calibrated. Standing by.',
  emote_greet_engage_discretion: 'Engage at your discretion.',
  emote_greet_prepare_annihilation: 'Prepare for annihilation.',
  emote_taunt_smells_weakling: 'It smells like weakling in here',
  emote_taunt_no_challenge: 'You are no challenge for me',
  emote_taunt_end_nigh: 'Your end is nigh',
  emote_taunt_time_to_die: 'Time to die',
  emote_taunt_wont_survive: "You won't survive this",
  emote_taunt_wont_enjoy: "I know you won't enjoy whats next",
  emote_taunt_welcome_oblivion: 'Welcome to oblivion',
  emote_taunt_is_that_all: "Is that all you've got?",
  emote_taunt_try_harder: 'If only you could try harder',
  emote_taunt_expected_more: 'I expected more',
  emote_taunt_pathetic: 'Pathetic…',
  emote_taunt_too_easy: "You're making this too easy",
  emote_taunt_feel_sorry: 'I feel sorry for you',
  emote_taunt_will_be_quick: 'This will be quick',
  emote_taunt_defeat_inevitable: 'Your defeat is inevitable',
  emote_taunt_painfully_irrelevant: 'You are painfully irrelevant',
  emote_taunt_thanks_laugh: 'Thanks for making me laugh',
  emote_taunt_watching_closely: 'Are you watching closely?',
  emote_taunt_losing_skill: 'Losing is the only skill you mastered',
  emote_taunt_wont_end_well: "This won't end well for you",
  emote_taunt_go_home: 'Go. Home. Now.',
  emote_taunt_impressive_opposite: 'Impressive. No wait… the opposite',
  emote_thanks_thank_you_friend: 'Thank you, friend',
  emote_thanks_thanks: 'Thanks',
  emote_thanks_shouldnt_have: "You shouldn't have",
  emote_thanks_my_thanks: 'My thanks',
  emote_thanks_how_nice: 'Oooh, how nice!',
  emote_thanks_have_my_thanks: 'You have my thanks',
  emote_thanks_nice_of_you: 'How nice of you',
  emote_thanks_i_guess: 'Thanks, I guess?',
  emote_good_game_impressive_display: 'This was an impressive display',
  emote_good_game_well_done: 'Well done',
  emote_good_game_engaging_battle: 'That was an engaging battle',
  emote_good_game_impressive: 'An impressive display',
  emote_good_game_powerful: 'You are powerful',
  emote_good_game_worthy_encounter: 'A worthy encounter',
  emote_good_game_stellar: 'That was stellar',
  emote_good_game_most_impressive: 'Most impressive',
  emote_good_game_was_fun: 'That was fun',
  emote_good_game_nicely_done: 'Nicely done',
  emote_good_game_intense: 'That was intense!',
  emote_good_game_solid_display: 'Solid display',
  emote_good_game_enjoyed: 'I enjoyed that',
  emote_good_game_flawless_victory: 'Flawless victory',
  emote_good_game_glorious: 'That was glorious',
  emote_good_game_did_alright: 'You did alright',
  emote_good_game_was_something: 'This was… something',
  emote_laugh_ha_ha: 'Ha Ha',
  emote_laugh_he_he: 'He He',
  emote_laugh_hee_hee: 'Hee Hee',
  emote_laugh_heh: 'Heh.',
  emote_laugh_lol: 'lol',
  emote_laugh_lawl: 'lawl',
  emote_laugh_ho_ho: 'Ho Ho',
  emote_laugh_har_har: 'Har Har',
  emote_laugh_ehehe: 'ehehe',
  emote_laugh_ha: 'Ha',
  emote_wish_luck_best_luck: 'Best of luck to you',
  emote_wish_luck_fortune_guide: 'May fortune guide your hand',
  emote_wish_luck_fight_honor: 'Fight with honor',
  emote_wish_luck_aim_true: 'May your aim be true',
  emote_wish_luck_dont_hold_back: "Don't hold back",
  emote_wish_luck_make_interesting: 'Make this interesting',
  emote_wish_luck_show_what_made: "Show me what you're made of",
  emote_wish_luck_good_luck_friend: 'Good luck, friend',
  emote_wish_luck_luck_favor: 'May luck favor you',
  emote_wish_luck_best_shot: 'Give me your best shot',
  emote_wish_luck_worthy_encounter: "Let's make this a worthy ecounter",
  emote_wish_luck_everything_got: "Bring everything you've got",
  emote_wish_luck_push_limits: 'Push me to my limits',
  emote_wish_luck_surprise_if_can: 'Surprise me…if you can',
  emote_wish_luck_not_disappoint: 'Try not to disappoint',
  emote_wish_luck_make_sweat: 'Make me sweat a little',
  emote_wish_luck_reason_remember: 'Give me a reason to remember you',
  emote_wish_luck_not_boring: "Don't make this boring",
  emote_wish_luck_victory_fearless: 'Victorey belongs to the fearless',
  emote_wake_up_wake_up: 'Wake up!',
  emote_wake_up_still_there: 'Are you still there',
  emote_wake_up_fall_asleep: 'Did you fall asleep?',
  emote_wake_up_speed_up: 'Can you speed this up?',
  emote_wake_up_tick_tock: 'Tick-tock, friend',
  emote_wake_up_time_not_infinite: 'Time is not infinite',
  emote_wake_up_could_do_something: 'You could do something',
  emote_wake_up_forget_about_me: 'Did you forget about me?',
  emote_wake_up_you_there: 'You there?',
  emote_wake_up_guess_wonder: 'I guess you wonder?',
  emote_wake_up_your_turn: 'Your turn',
  emote_wake_up_roping: 'Oh. Wow. Roping.',
  emote_wake_up_time_waits: 'Time waits for noone',
  emote_wake_up_make_haste: 'Make haste',
  emote_wake_up_act_or_not: 'To act or not to act?',
};

export const EMOTE_SPEECH_LINES_DE = {
  emote_good_game: 'Gutes Spiel!',
  emote_greet: 'Hallo!',
  emote_laugh: 'Haha!',
  emote_oops: 'Ups!',
  emote_taunt: 'Du bist mir nicht gewachsen!',
  emote_thanks: 'Danke!',
  emote_wake_up: 'Wach auf!',
  emote_well_played: 'Gut gespielt!',
  emote_wish_luck: 'Viel Glück!',
  emote_greet_stars_align: 'Mögen sich die Sterne für dich zum Guten fügen',
  emote_greet_signal_locked: 'Signal gesperrt. Los geht’s',
  emote_greet_salutations: 'Salve',
  emote_greet_commander_deck: 'Kommandant an Bord!',
  emote_greet_victory_awaits: 'Der Sieg wartet',
  emote_greet_for_earth: 'Für die Erde!',
  emote_greet_lets_get_on: 'Legen wir los',
  emote_greet_beep_bopp: 'Beep. Bopp!',
  emote_greet_prepare_bad_time: 'Mach dich auf was gefasst',
  emote_greet_meet_end_dignity: 'Begegne deinem Ende mit Würde',
  emote_greet_hello_friend: 'Hallo, Freund',
  emote_greet_we_finally_meet: 'Endlich treffen wir uns!',
  emote_greet_those_who_die: 'Die im Sterben liegen, grüßen dich',
  emote_greet_all_systems_go: 'Alle Systeme stehen auf Grün!',
  emote_greet_ready_fate: 'Bereit, mein Schicksal zu treffen',
  emote_greet_here_we_go: 'Und los!',
  emote_greet_atoms_oscillate: 'Mögen deine Atome harmonisch schwingen',
  emote_greet_resistance_appreciated: 'Widerstand wird geschätzt',
  emote_greet_small_challenge: 'Versuch wenigstens ein bisschen was zu bieten',
  emote_greet_systems_calibrated: 'Systeme kalibriert. Stehe bereit.',
  emote_greet_engage_discretion: 'Greif nach eigenem Ermessen an.',
  emote_greet_prepare_annihilation: 'Bereite dich auf die Vernichtung vor.',
  emote_taunt_smells_weakling: 'Hier riecht’s nach Schwächling',
  emote_taunt_no_challenge: 'Du bist keine Herausforderung für mich',
  emote_taunt_end_nigh: 'Dein Ende ist nah',
  emote_taunt_time_to_die: 'Zeit zu sterben',
  emote_taunt_wont_survive: 'Das überlebst du nicht',
  emote_taunt_wont_enjoy: 'Das wird dir nicht gefallen',
  emote_taunt_welcome_oblivion: 'Willkommen im Vergessen',
  emote_taunt_is_that_all: 'Das war’s?',
  emote_taunt_try_harder: 'Wenn du dich nur anstrengen könntest',
  emote_taunt_expected_more: 'Ich hatte mehr erwartet',
  emote_taunt_pathetic: 'Erbärmlich…',
  emote_taunt_too_easy: 'Du machst mir das viel zu leicht',
  emote_taunt_feel_sorry: 'Du tust mir leid',
  emote_taunt_will_be_quick: 'Das geht schnell',
  emote_taunt_defeat_inevitable: 'Deine Niederlage ist unvermeidlich',
  emote_taunt_painfully_irrelevant: 'Du bist schmerzhaft irrelevant',
  emote_taunt_thanks_laugh: 'Danke fürs Lachen',
  emote_taunt_watching_closely: 'Passt du gut auf?',
  emote_taunt_losing_skill: 'Verlieren ist die einzige Fähigkeit, die du gemeistert hast',
  emote_taunt_wont_end_well: 'Das wird für dich nicht gut enden',
  emote_taunt_go_home: 'Geh. Nach. Hause.',
  emote_taunt_impressive_opposite: 'Beeindruckend. Nein, warte… das Gegenteil',
  emote_thanks_thank_you_friend: 'Danke, Freund',
  emote_thanks_thanks: 'Danke',
  emote_thanks_shouldnt_have: 'Das hättest du nicht tun müssen',
  emote_thanks_my_thanks: 'Mein Dank',
  emote_thanks_how_nice: 'Oooh, wie nett!',
  emote_thanks_have_my_thanks: 'Du hast meinen Dank',
  emote_thanks_nice_of_you: 'Wie nett von dir',
  emote_thanks_i_guess: 'Danke, denke ich?',
  emote_good_game_impressive_display: 'Das war eine beeindruckende Leistung',
  emote_good_game_well_done: 'Gut gemacht',
  emote_good_game_engaging_battle: 'Das war ein packender Kampf',
  emote_good_game_impressive: 'Eine beeindruckende Leistung',
  emote_good_game_powerful: 'Du bist stark',
  emote_good_game_worthy_encounter: 'Eine würdige Begegnung',
  emote_good_game_stellar: 'Das war stellar',
  emote_good_game_most_impressive: 'Sehr beeindruckend',
  emote_good_game_was_fun: 'Das hat Spaß gemacht',
  emote_good_game_nicely_done: 'Schön gemacht',
  emote_good_game_intense: 'Das war intensiv!',
  emote_good_game_solid_display: 'Solide Vorstellung',
  emote_good_game_enjoyed: 'Das hat mir gefallen',
  emote_good_game_flawless_victory: 'Makelloser Sieg',
  emote_good_game_glorious: 'Das war glorreich',
  emote_good_game_did_alright: 'War ganz okay',
  emote_good_game_was_something: 'Das war… etwas',
  emote_laugh_ha_ha: 'Ha ha',
  emote_laugh_he_he: 'He he',
  emote_laugh_hee_hee: 'Hi hi',
  emote_laugh_heh: 'Heh.',
  emote_laugh_lol: 'lol',
  emote_laugh_lawl: 'lawl',
  emote_laugh_ho_ho: 'Ho ho',
  emote_laugh_har_har: 'Har har',
  emote_laugh_ehehe: 'ehehe',
  emote_laugh_ha: 'Ha',
  emote_wish_luck_best_luck: 'Viel Glück dir',
  emote_wish_luck_fortune_guide: 'Möge das Glück deine Hand führen',
  emote_wish_luck_fight_honor: 'Kämpfe mit Ehre',
  emote_wish_luck_aim_true: 'Möge dein Ziel treffen',
  emote_wish_luck_dont_hold_back: 'Halt dich nicht zurück',
  emote_wish_luck_make_interesting: 'Mach’s interessant',
  emote_wish_luck_show_what_made: 'Zeig, wozu du fähig bist',
  emote_wish_luck_good_luck_friend: 'Viel Glück, Freund',
  emote_wish_luck_luck_favor: 'Möge das Glück dir hold sein',
  emote_wish_luck_best_shot: 'Gib dein Bestes',
  emote_wish_luck_worthy_encounter: 'Machen wir daraus eine würdige Begegnung',
  emote_wish_luck_everything_got: 'Bring alles mit, was du hast',
  emote_wish_luck_push_limits: 'Fordere mich heraus',
  emote_wish_luck_surprise_if_can: 'Überrasch mich… wenn du kannst',
  emote_wish_luck_not_disappoint: 'Versuch, nicht zu enttäuschen',
  emote_wish_luck_make_sweat: 'Lass mich ein bisschen schwitzen',
  emote_wish_luck_reason_remember: 'Gib mir einen Grund, dich zu erinnern',
  emote_wish_luck_not_boring: 'Mach’s nicht langweilig',
  emote_wish_luck_victory_fearless: 'Der Sieg gehört den Furchtlosen',
  emote_wake_up_wake_up: 'Wach auf!',
  emote_wake_up_still_there: 'Bist du noch da?',
  emote_wake_up_fall_asleep: 'Bist du eingeschlafen?',
  emote_wake_up_speed_up: 'Kannst du dich beeilen?',
  emote_wake_up_tick_tock: 'Tick-tack, Freund',
  emote_wake_up_time_not_infinite: 'Die Zeit ist nicht unendlich',
  emote_wake_up_could_do_something: 'Du könntest was tun',
  emote_wake_up_forget_about_me: 'Hast du mich vergessen?',
  emote_wake_up_you_there: 'Halloo?',
  emote_wake_up_guess_wonder: 'Ich schätze, du fragst dich was?',
  emote_wake_up_your_turn: 'Du bist dran',
  emote_wake_up_roping: 'Oh. Wow. Zeit schinden.',
  emote_wake_up_time_waits: 'Die Zeit wartet auf niemanden',
  emote_wake_up_make_haste: 'Beeil dich',
  emote_wake_up_act_or_not: 'Handeln oder nicht?',
};

export const EMOTE_SPEECH_LINES_ES = {
  emote_good_game: '¡Buen juego!',
  emote_greet: '¡Hola!',
  emote_laugh: '¡Ja, ja!',
  emote_oops: '¡Uy!',
  emote_taunt: '¡No eres rival para mí!',
  emote_thanks: '¡Gracias!',
  emote_wake_up: '¡Despierta!',
  emote_well_played: '¡Bien jugado!',
  emote_wish_luck: '¡Buena suerte!',
  emote_greet_stars_align: 'Que las estrellas se alineen a tu favor',
  emote_greet_signal_locked: 'Señal bloqueada. Vamos allá',
  emote_greet_salutations: 'Saludos',
  emote_greet_commander_deck: '¡El comandante en el campo!',
  emote_greet_victory_awaits: 'La victoria te espera',
  emote_greet_for_earth: '¡Por la Tierra!',
  emote_greet_lets_get_on: 'Pongámonos en marcha',
  emote_greet_beep_bopp: 'Beep. ¡Bopp!',
  emote_greet_prepare_bad_time: 'Prepárate para pasarlo mal',
  emote_greet_meet_end_dignity: 'Encuentra tu fin con dignidad',
  emote_greet_hello_friend: 'Hola, amigo',
  emote_greet_we_finally_meet: '¡Por fin nos vemos!',
  emote_greet_those_who_die: 'Los que están a punto de morir te saludan',
  emote_greet_all_systems_go: '¡Todos los sistemas en marcha!',
  emote_greet_ready_fate: 'Listo para encontrarme con el destino',
  emote_greet_here_we_go: '¡Allá vamos!',
  emote_greet_atoms_oscillate: 'Que tus átomos oscilen en armonía',
  emote_greet_resistance_appreciated: 'Se agradece la resistencia',
  emote_greet_small_challenge: 'Intenta al menos suponer un reto',
  emote_greet_systems_calibrated: 'Sistemas calibrados. En espera.',
  emote_greet_engage_discretion: 'Ataca a tu discreción.',
  emote_greet_prepare_annihilation: 'Prepárate para la aniquilación.',
  emote_taunt_smells_weakling: 'Aquí huele a debilucho',
  emote_taunt_no_challenge: 'No eres rival para mí',
  emote_taunt_end_nigh: 'Tu fin está cerca',
  emote_taunt_time_to_die: 'Hora de morir',
  emote_taunt_wont_survive: 'No sobrevivirás a esto',
  emote_taunt_wont_enjoy: 'Sé que lo siguiente no te va a gustar',
  emote_taunt_welcome_oblivion: 'Bienvenido al olvido',
  emote_taunt_is_that_all: '¿Eso es todo lo que tienes?',
  emote_taunt_try_harder: 'Si al menos pudieras esforzarte más',
  emote_taunt_expected_more: 'Esperaba más',
  emote_taunt_pathetic: 'Patético…',
  emote_taunt_too_easy: 'Me lo estás poniendo demasiado fácil',
  emote_taunt_feel_sorry: 'Me das pena',
  emote_taunt_will_be_quick: 'Esto será rápido',
  emote_taunt_defeat_inevitable: 'Tu derrota es inevitable',
  emote_taunt_painfully_irrelevant: 'Eres dolorosamente irrelevante',
  emote_taunt_thanks_laugh: 'Gracias por hacerme reír',
  emote_taunt_watching_closely: '¿Estás mirando bien?',
  emote_taunt_losing_skill: 'Perder es la única habilidad que dominas',
  emote_taunt_wont_end_well: 'Esto no te va a salir bien',
  emote_taunt_go_home: 'Vete. A. Casa.',
  emote_taunt_impressive_opposite: 'Impresionante. No, espera… todo lo contrario',
  emote_thanks_thank_you_friend: 'Gracias, amigo',
  emote_thanks_thanks: 'Gracias',
  emote_thanks_shouldnt_have: 'No tenías que',
  emote_thanks_my_thanks: 'Mi agradecimiento',
  emote_thanks_how_nice: '¡Oh, qué amable!',
  emote_thanks_have_my_thanks: 'Tienes mi gratitud',
  emote_thanks_nice_of_you: 'Qué amable por tu parte',
  emote_thanks_i_guess: 'Gracias, ¿supongo?',
  emote_good_game_impressive_display: 'Ha sido una actuación impresionante',
  emote_good_game_well_done: 'Bien hecho',
  emote_good_game_engaging_battle: 'Ha sido un combate absorbente',
  emote_good_game_impressive: 'Una actuación impresionante',
  emote_good_game_powerful: 'Eres poderoso',
  emote_good_game_worthy_encounter: 'Un encuentro digno',
  emote_good_game_stellar: 'Ha sido estelar',
  emote_good_game_most_impressive: 'Lo más impresionante',
  emote_good_game_was_fun: 'Ha sido divertido',
  emote_good_game_nicely_done: 'Muy bien hecho',
  emote_good_game_intense: '¡Ha sido intenso!',
  emote_good_game_solid_display: 'Exhibición sólida',
  emote_good_game_enjoyed: 'Lo he disfrutado',
  emote_good_game_flawless_victory: 'Victoria impecable',
  emote_good_game_glorious: 'Ha sido glorioso',
  emote_good_game_did_alright: 'No estuvo mal',
  emote_good_game_was_something: 'Esto ha sido… algo',
  emote_laugh_ha_ha: 'Ja, ja',
  emote_laugh_he_he: 'Je, je',
  emote_laugh_hee_hee: 'Ji, ji',
  emote_laugh_heh: 'Je.',
  emote_laugh_lol: 'lol',
  emote_laugh_lawl: 'lawl',
  emote_laugh_ho_ho: 'Jo, jo',
  emote_laugh_har_har: 'Jar, jar',
  emote_laugh_ehehe: 'ejeje',
  emote_laugh_ha: 'Ja',
  emote_wish_luck_best_luck: 'Mucha suerte',
  emote_wish_luck_fortune_guide: 'Que la fortuna guíe tu mano',
  emote_wish_luck_fight_honor: 'Lucha con honor',
  emote_wish_luck_aim_true: 'Que tu puntería sea certera',
  emote_wish_luck_dont_hold_back: 'No te contengas',
  emote_wish_luck_make_interesting: 'Hazlo interesante',
  emote_wish_luck_show_what_made: 'Muéstrame de qué estás hecho',
  emote_wish_luck_good_luck_friend: 'Buena suerte, amigo',
  emote_wish_luck_luck_favor: 'Que la suerte te favorezca',
  emote_wish_luck_best_shot: 'Dame lo mejor que tengas',
  emote_wish_luck_worthy_encounter: 'Hagamos de esto un encuentro digno',
  emote_wish_luck_everything_got: 'Trae todo lo que tengas',
  emote_wish_luck_push_limits: 'Ponme a prueba',
  emote_wish_luck_surprise_if_can: 'Sorpréndeme… si puedes',
  emote_wish_luck_not_disappoint: 'Intenta no decepcionar',
  emote_wish_luck_make_sweat: 'Hazme sudar un poco',
  emote_wish_luck_reason_remember: 'Dame un motivo para recordarte',
  emote_wish_luck_not_boring: 'Que no sea aburrido',
  emote_wish_luck_victory_fearless: 'La victoria es de los audaces',
  emote_wake_up_wake_up: '¡Despierta!',
  emote_wake_up_still_there: '¿Sigues ahí?',
  emote_wake_up_fall_asleep: '¿Te has quedado dormido?',
  emote_wake_up_speed_up: '¿Puedes ir más rápido?',
  emote_wake_up_tick_tock: 'Tic-tac, amigo',
  emote_wake_up_time_not_infinite: 'El tiempo no es infinito',
  emote_wake_up_could_do_something: 'Podrías hacer algo',
  emote_wake_up_forget_about_me: '¿Te has olvidado de mí?',
  emote_wake_up_you_there: '¿Hola?',
  emote_wake_up_guess_wonder: 'Supongo que te lo preguntas',
  emote_wake_up_your_turn: 'Tu turno',
  emote_wake_up_roping: 'Oh. Vaya. A estirar el tiempo.',
  emote_wake_up_time_waits: 'El tiempo no espera a nadie',
  emote_wake_up_make_haste: 'Date prisa',
  emote_wake_up_act_or_not: '¿Actuar o no actuar?',
};

/** Keys present in all three maps (for sanity checks). */
export const EMOTE_SPEECH_LINE_KEYS = Object.freeze(Object.keys(EMOTE_SPEECH_LINES_EN));
